<template>
    <AdminLayout>
        <template #header>
            <Breadcrumb :items="items" />
        </template>

        <div class="container papers-page">
            <div class="papers-grid">
                <!-- Upload -->
                <PaperUploadPanel @created="onPaperCreated" />

                <!-- Library — the rows hand their paper up, and the dialogs below open on it. -->
                <PaperLibraryPanel ref="libraryRef" @edit="openEditDialog" @manage="openManageDialog" />
            </div>
        </div>

        <ConfirmDialog></ConfirmDialog>

        <!-- Edit details -->
        <PaperDetailsDialog v-model:visible="editDialogVisible" :paper="editedPaper" @saved="onPaperSaved" />

        <!-- Manage files -->
        <PaperFilesDialog v-model:visible="manageDialogVisible" :paper="managedPaper" @updated="applyUpdatedPaper" />
    </AdminLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AdminLayout from '@/layout/AdminLayout.vue'
import Breadcrumb from '@/components/CustomBreadcrumb.vue'
import PaperUploadPanel from '@/components/dashboard/admin/pastPapers/PaperUploadPanel.vue'
import PaperLibraryPanel from '@/components/dashboard/admin/pastPapers/PaperLibraryPanel.vue'
import PaperDetailsDialog from '@/components/dashboard/admin/pastPapers/PaperDetailsDialog.vue'
import PaperFilesDialog from '@/components/dashboard/admin/pastPapers/PaperFilesDialog.vue'
import ConfirmDialog from 'primevue/confirmdialog';
import { fetchGradeOptions } from '@/utils/options';

const items = ref([{ label: "Past Papers" }])
const libraryRef = ref(null);
const onPaperCreated = () => libraryRef.value?.refresh(1);

const editDialogVisible = ref(false);
const editedPaper = ref(null);

const openEditDialog = (paper) => {
    editedPaper.value = paper;
    editDialogVisible.value = true;
};

const onPaperSaved = () => libraryRef.value?.refresh();

const manageDialogVisible = ref(false);
const managedPaper = ref(null);

const openManageDialog = (paper) => {
    managedPaper.value = paper;
    manageDialogVisible.value = true;
};

const applyUpdatedPaper = (updated) => {
    if (!updated) return;
    managedPaper.value = updated;
    libraryRef.value?.applyPaper(updated);
};

onMounted(() => {
    fetchGradeOptions();
})
</script>

<style scoped>
.papers-page {
    width: 100%;
}

.papers-grid {
    display: grid;
    grid-template-columns: minmax(0, 5fr) minmax(0, 6fr);
    gap: 1.25rem;
    align-items: stretch;
}

@media (max-width: 1200px) {
    .papers-grid {
        grid-template-columns: minmax(0, 1fr);
    }
}
</style>

<style>
.papers-dialog .p-dialog-header {
    padding: 1rem 1.25rem;
    border-bottom: 1px solid var(--black-50);
    background: linear-gradient(180deg, #F7F9FD 0%, #FFFFFF 100%);
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}

.papers-dialog .p-dialog-title {
    font-size: 1rem;
    font-weight: 600;
    color: var(--black-500);
}

.papers-dialog .p-dialog-content {
    padding: 1.25rem;
}

.papers-dialog .p-dialog-footer {
    padding: 0.85rem 1.25rem;
    border-top: 1px solid var(--black-50);
    gap: 0.5rem;
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
}
</style>
